import * as React from 'react'
import { ReactElement } from 'react'
import BaseTagPicker, { BaseTagPickerProps } from './BaseTagPicker'
import { UserListItemDto, UserStatus } from '../../config/userConfig'
import useUsers from '../../hooks/useUsers'

type Props = Partial<BaseTagPickerProps<UserListItemDto>> &
    Required<Pick<BaseTagPickerProps<UserListItemDto>, 'selectedOptions' | 'onOptionsSelect'>>

export default function UserPicker(props: Props): ReactElement {
    const users = useUsers()

    return (
        <BaseTagPicker<UserListItemDto>
            entities={users.users}
            filter={entity =>
                (props.filter?.(entity) ?? entity.status === UserStatus.Enabled) ||
                props.selectedOptions?.some(id => id === entity.id)
            }
            alphabetical
            getEntityValue={user => user.id}
            getEntityTagLabel={file => file.fullName}
            getEntityLabel={user => user.fullName}
            placeholderKey={'base.userpicker.placeholder'}
            {...props}
        />
    )
}
